import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

type Props = {
  auditId: string;
  alreadyCompleted: boolean;
  leadEmail: string;
  onChange?: () => void;
};

export function CompleteButton({
  auditId,
  alreadyCompleted,
  leadEmail,
  onChange,
}: Props) {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!window.confirm(`Send the results email to ${leadEmail} now?`)) {
      return;
    }

    setError(null);
    setLoading(true);

    const res = await api<{ status: string }>(`/admin/audits/${auditId}/complete`, {
      method: "POST",
    });

    if (!res.ok) {
      setError(res.error ?? "Failed to send completion email");
      setLoading(false);
      return;
    }

    setLoading(false);
    onChange?.();
  };

  return (
    <div>
      <Button onClick={handleClick} disabled={alreadyCompleted || loading}>
        {loading && <Loader2 className="animate-spin" />}
        {alreadyCompleted ? "Already sent" : `Send results to ${leadEmail}`}
      </Button>
      {error && (
        <p className="mt-2 text-sm text-destructive" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
